export function fileNameWithoutExtension(fileName: string): string {
  return fileName?.substring(0, fileName?.lastIndexOf('.')) || '';
}
